// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-minicart',
    // #endregion
    // #region Core
    methods: {
        onClick(cart, event) {
            // #region Check
            if (event.target?.localName === 'a') {
                return;
            }
            // #endregion
            // #region Prevent
            event.preventDefault();
            // #endregion
            // #region Read-Only
            if (cart.isReadOnly) {
                this.$router.push(`/checkout/${cart.cartID}`);
            }
            // #endregion
            // #region Send
            else {
                host.api.post(`commerce/carts/${cart.cartID}/activate`)
                    .then(e => {
                    // #region Store
                    this.$store.commit('carts/load');
                    // #endregion                        
                })
                    .catch(e => {
                    host.notification.showToast(utils.getAxiosErrorMessage(e));
                });
            }
            // #endregion                
        },
        createCart() {
            host.notification.showModal(host.components.getComponent('g-cart-create-dialog'), {}, { size: 'default' });
        }
    },
    // #endregion
});
// #endregion
